import { callApi } from 'loankeeper-common/api'

export const search = (params) =>
  callApi('loan_search', {
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
    params,
    body: {},
    method: 'post',
  })

export const loanView = (params) =>
  callApi('loan_view', {
    method: 'post',
    params,
    body: {},
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })

export const loanOper = ({ page, ...body }) =>
  callApi('loan_oper', {
    method: 'post',
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
    params: { page },
    body,
  })

export const disburse = (config) =>
  callApi('loan_oper', {
    method: 'post',
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
    ...config,
  })

// export const visa = ({ ID, hash, WHLSessionID, HashSum_WHLSessionID_ }) =>
//   loanOper({
//     page: 'visa',
//     LoanID: ID,
//     HashSum_LoanID_: hash,
//     WHLSessionID,
//     HashSum_WHLSessionID_,
//   })

// export const loanOperPost = (config) =>
//   callApi('loan_oper_post', {
//     method: 'post',
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//     ...config,
//   })

/* specific request functions */

export const print = loanView

export const details = ({ ID, hash, page, additionalParams }) =>
  loanView({
    LoanID: ID,
    HashSum_LoanID_: hash,
    page,
    ActiveOperFlag: 1,
    ...additionalParams,
  })

// export const fetchConditionInitialFields = ({ ID, hash }) =>
//   loanView({
//     LoanID: ID,
//     HashSum_LoanID_: hash,
//     page: 'conditions_curr',
//   })

// export const updateResourceID = (ID, loanID, loanHash) =>
//   loanOper({
//     LoanID: loanID,
//     HashSum_LoanID_: loanHash,
//     page: 'resourceupdate',
//     ResourceID: ID,
//   })

// export const updateAgreementNumber = (number, loanID, loanHash) =>
//   loanOper({
//     LoanID: loanID,
//     HashSum_LoanID_: loanHash,
//     page: 'agreementnumberupdate',
//     AgreementNo: number,
//   })

// export const updateNodeID = (ID, loanID, loanHash) =>
//   loanOper({
//     LoanID: loanID,
//     HashSum_LoanID_: loanHash,
//     page: 'nodeupdate',
//     NodeID: ID,
//   })
export const updateAgreementNumber = (number, loanID, loanHash) =>
  loanOper({
    LoanID: loanID,
    HashSum_LoanID_: loanHash,
    page: 'agreementnumberupdate',
    AgreementNo: number,
  })

export const updateNodeID = (ID, loanID, loanHash) =>
  loanOper({
    LoanID: loanID,
    HashSum_LoanID_: loanHash,
    page: 'nodeupdate',
    NodeID: ID,
  })

// export const stopAccruals = (ID, hash) =>
//   loanOper({
//     LoanID: ID,
//     HashSum_LoanID_: hash,
//     page: 'accrualstop',
//   })

// export const undoStopAccruals = (ID, hash) =>
//   loanOper({
//     LoanID: ID,
//     HashSum_LoanID_: hash,
//     page: 'accrualstopundo',
//   })

// export const addCondition = (params) =>
//   loanOper({
//     ...params,
//     page: 'conditionadd',
//   })

// export const deleteCondition = (params) =>
//   loanOper({
//     ...params,
//     page: 'conditiondelete',
//   })

// export const addOfficerAssistant = loanOper

// export const deleteOfficer = (params) =>
//   loanOper({
//     ...params,
//     page: 'officerdelete',
//   })

// export const deleteAssistant = (params) =>
//   loanOper({
//     ...params,
//     page: 'assistantdelete',
//   })

// export const deleteTransaction = (params) =>
//   loanOper({
//     ...params,
//     page: 'transactiondelete',
//   })

// export const writeOff = (params) =>
//   loanOper({
//     ...params,
//     page: 'writeoff',
//   })

// export const writeOffData = (params) =>
//   loanView({
//     ...params,
//     page: 'writeoffdata',
//   })

// export const updateComments = (ID, hash, Comment, CField1, CField2, CField3, CField4) =>
//   loanOperPost({
//     params: {
//       LoanID: ID,
//       HashSum_LoanID_: hash,
//       page: 'comments',
//     },
//     body: {
//       Comment,
//       CField1,
//       CField2,
//       CField3,
//       CField4,
//     },
//   })

// export const addTag = (params) =>
//   loanOper({
//     ...params,
//     page: 'tagadd',
//   })
export const addTag = (params) =>
  loanOper({
    ...params,
    page: 'tagadd',
  })

// export const deleteTag = (params) =>
//   loanOper({
//     ...params,
//     page: 'tagdelete',
//   })

// export const addNote = ({
//   LoanID,
//   hash,
//   StateID,
//   PriorityID,
//   TypeID,
//   NodeID,
//   LFLID,
//   GDate,
//   Comment,
//   FileID,
//   HashSum_FileID_,
// }) =>
//   loanOperPost({
//     params: {
//       LoanID,
//       HashSum_LoanID_: hash,
//       page: 'noteadd',
//     },
//     body: {
//       StateID,
//       PriorityID,
//       TypeID,
//       NodeID,
//       LFLID,
//       GDate,
//       Comment,
//       FileID,
//       HashSum_FileID_,
//     },
//   })

// export const editNote = ({
//   LoanID,
//   hash,
//   ID,
//   StateID,
//   PriorityID,
//   TypeID,
//   NodeID,
//   LFLID,
//   GDate,
//   Comment,
//   HashSum_FileID_,
//   FileID,
// }) =>
//   loanOperPost({
//     params: {
//       LoanID,
//       HashSum_LoanID_: hash,
//       page: 'noteedit',
//     },
//     body: {
//       ID,
//       StateID,
//       PriorityID,
//       TypeID,
//       NodeID,
//       LFLID,
//       GDate,
//       Comment,
//       HashSum_FileID_,
//       FileID,
//     },
//   })

// export const deleteNote = ({ LoanID, hash, ID }) =>
//   loanOperPost({
//     params: {
//       LoanID,
//       HashSum_LoanID_: hash,
//       page: 'notedelete',
//     },
//     body: {
//       ID,
//     },
//   })

// export const fetchLoanNotes = (ID, hash) =>
//   callApi('loan_view', {
//     params: {
//       page: 'activenotes',
//       LoanID: ID,
//       HashSum_LoanID_: hash,
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const fetchPermissions = (ID, hash) =>
//   loanView({
//     LoanID: ID,
//     HashSum_LoanID_: hash,
//     page: 'accessperms',
//   })

// export const addPermission = (ID, LoanID, hash) =>
//   loanOper({
//     LoanID,
//     HashSum_LoanID_: hash,
//     page: 'accesspermadd',
//     ID,
//   })

// export const deletePermission = (ID, LoanID, hash) =>
//   loanOper({
//     LoanID,
//     HashSum_LoanID_: hash,
//     page: 'accesspermdelete',
//     ID,
//   })

// export const reserveManual = (LoanID, hash, ID) =>
//   loanOper({
//     LoanID,
//     HashSum_LoanID_: hash,
//     page: 'reservemanual',
//     ID,
//   })

// export const reserveAuto = (LoanID, hash) =>
//   loanOper({a
//     LoanID,
//     HashSum_LoanID_: hash,
//     page: 'reserveauto',
//   })

// export const schedule = (params) =>
//   callApi('loan_schedule', {
//     params,
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const add = (params, body) =>
//   callApi('loan_add', {
//     method: 'post',
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//     params,
//     body,
//   })

// export const linkCollateral = (ID, hash, CollateralID, CollateralHash) =>
//   loanOper({
//     LoanID: ID,
//     HashSum_LoanID_: hash,
//     CollateralID,
//     HashSum_CollateralID_: CollateralHash,
//     page: 'linkcollateral',
//   })
export const linkCollateral = (ID, hash, CollateralID, CollateralHash) =>
  loanOper({
    LoanID: ID,
    HashSum_LoanID_: hash,
    CollateralID,
    HashSum_CollateralID_: CollateralHash,
    page: 'linkcollateral',
  })

// export const unlinkCollateral = (ID, hash, CollateralID, CollateralHash) =>
//   loanOper({
//     LoanID: ID,
//     HashSum_LoanID_: hash,
//     CollateralID,
//     HashSum_CollateralID_: CollateralHash,
//     page: 'unlinkcollateral',
//   })

// export const addEditMonitoring = ({
//   ID,
//   HashSum_LoanMonID_,
//   LoanID,
//   LoanHash,
//   TypeID,
//   SDate,
//   Comment,
//   Criterium1,
//   Criterium2,
//   Criterium3,
//   Criterium4,
//   Criterium5,
//   Criterium6,
//   FileID,
//   HashSum_FileID_,
// }) =>
//   loanOperPost({
//     params: {
//       page: ID ? 'monitoringedit' : 'monitoringadd',
//       LoanID,
//       HashSum_LoanID_: LoanHash,
//     },
//     body: {
//       ID,
//       HashSum_LoanMonID_,
//       SDate,
//       TypeID,
//       Criterium1,
//       Criterium2,
//       Criterium3,
//       Criterium4,
//       Criterium5,
//       Criterium6,
//       Comment,
//       FileID,
//       HashSum_FileID_,
//     },
//   })

// export const deleteMonitoring = ({ ID, hash, LoanID, LoanHash }) =>
//   loanOperPost({
//     params: {
//       page: 'monitoringdelete',
//       LoanID,
//       HashSum_LoanID_: LoanHash,
//     },
//     body: {
//       ID,
//       HashSum_LoanMonID_: hash,
//     },
//   })

// export const updateCustomFields = (ID, hash, data) =>
//   loanOperPost({
//     params: {
//       LoanID: ID,
//       HashSum_LoanID_: hash,
//       page: 'custfieldsupdate',
//     },
//     body: {
//       DynFieldData: data,
//     },
//   })

// export const cover = (config) =>
//   callApi('loan_cover', {
//     method: 'post',
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//     ...config,
//   })

// export const closeRevolving = (ID, hash) =>
//   loanOper({
//     LoanID: ID,
//     HashSum_LoanID_: hash,
//     page: 'closerevolving',
//   })
export const closeRevolving = (ID, hash) =>
  loanOper({
    LoanID: ID,
    HashSum_LoanID_: hash,
    page: 'closerevolving',
  })

// export const accountsCover = (ID, hash) =>
//   callApi('loan_view', {
//     params: {
//       page: 'accounts_cover',
//       LoanID: ID,
//       HashSum_LoanID_: hash,
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const accountsCoverCash = (ID, hash) =>
//   callApi('loan_view', {
//     params: {
//       page: 'accounts_cover_cash',
//       LoanID: ID,
//       HashSum_LoanID_: hash,
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const accountsDisburseCash = (ID, hash) =>
//   callApi('loan_view', {
//     params: {
//       page: 'accounts_disburse_cash',
//       LoanID: ID,
//       HashSum_LoanID_: hash,
//     },
//     body: {},
//     method: 'post',
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const printLoanSchedule = ({ ID, hash }) =>
//   callApi('loan_view', {
//     params: {
//       page: 'printloanschedule',
//       LoanID: ID,
//       HashSum_LoanID_: hash,
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })
